<template>
  <section class="p-2">
    <v-tabs color="primary" v-model="tabSeleted" slider-color="primary">
      <v-tab
        v-for="item in items"
        :key="item.key"
        :href="'#' + item.key"
        :disabled="item.disabled"
        color="white"
        class="text-capitalize text-decoration-none"
      >
        {{ item.label }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabSeleted">
      <v-tab-item id="ctcrates"> <ctcDashboardRates /></v-tab-item>
      <v-tab-item id="btbrates"><btbDashboardRates /> </v-tab-item>
    </v-tabs-items>

    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import ctcDashboardRates from "../DashboardRatesTab/ctcDashboardRates.vue";
import btbDashboardRates from "../DashboardRatesTab/btbDashboardRates.vue";
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
export default {
  name: "Create Partner",
  components: {
    Loading,
    ctcDashboardRates,
    btbDashboardRates,
  },
  mixins: [alerts],
  data() {
    return {
      currentItem: "",
      loader: false,
      tabSeleted: 0,
      items: [
        { label: "CTC Rates", key: "ctcrates" },

        {
          label: "BTB Rates",
          key: "btbrates",
        },
      ],
    };
  },

  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
